import { Search } from "lucide-react";

type SearchInputProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  /** Accessible name for the search field, kept out of the visual layout. */
  ariaLabel?: string;
  className?: string;
};

export const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  ariaLabel = "Rechercher",
  className = "",
}: SearchInputProps) => {
  return (
    <div className={`relative w-full flex-1 ${className}`}>
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
        <Search className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>

      <input
        type="text"
        aria-label={ariaLabel}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="
          w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-2.5 sm:py-3
          text-sm sm:text-base border rounded-lg
          focus:outline-none focus:ring-2 focus:ring-ring
          placeholder:text-muted-foreground
        "
      />
    </div>
  );
};
